import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/form-footer-container/form-footer-container.js';
      import {ObcFormFooterActionClickEvent} from '@oicl/openbridge-webcomponents/dist/components/form-footer-container/form-footer-container.js';

      export interface Props {
     hasActions?: boolean
   }

      
  
      export type {ObcFormFooterActionClickEvent} from '@oicl/openbridge-webcomponents/dist/components/form-footer-container/form-footer-container.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcFormFooterContainer',
  props: {
    hasActions: { type: Boolean }
  },
  emits: ["action-click"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onActionClick: (event: ObcFormFooterActionClickEvent) => emit('action-click', event as ObcFormFooterActionClickEvent)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-form-footer-container',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})